/**
 * TutorInvoicesScreen — « Mes factures » (route `tutoring-invoices`), à la place de
 * `tutor/invoices/TutoringInvoicesScreen.js` pour un tuteur dont l'espace est allumé.
 *
 * Patron A : les pages lues par `useTutorInvoicesData` dans le réducteur `tutors`, mises en forme par
 * `tutorInvoicesViewModel` ; l'ouverture d'un PDF, sa génération et la croix dans
 * `useTutorInvoicesState`.
 */
import React from "react"
import { useSelector } from "react-redux"

import { TutorInvoicesPage } from "../../../../../../design-system/tutor"
import { tutorInvoicesViewModel } from "../../../../view-models/tutor/Account/tutorInvoicesViewModel"
import { useTutorInvoicesData } from "./useTutorInvoicesData"
import { useTutorInvoicesState } from "./useTutorInvoicesState"

export function TutorInvoicesScreen() {
    const data = useTutorInvoicesData()
    const vm = useSelector((state: unknown) => tutorInvoicesViewModel(state, data.answered))
    const state = useTutorInvoicesState(vm.links)

    return (
        <TutorInvoicesPage
            invoices={vm.invoices}
            loading={vm.loading}
            error={vm.error}
            onRetry={data.reload}
            hasMore={data.hasMore}
            loadingMore={vm.loadingMore}
            onLoadMore={data.loadMore}
            {...state}
        />
    )
}
